import Quill from 'quill';
import { useMemo, useCallback } from 'react';

import { Dropdown } from '@hivebrite/design-system/Dropdown';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const CustomVariables = ({ variables }) => {
  const { quillRef, setForceEditorFocus } = useQuillEditorContext();

  const handleClickValue = useCallback(
    (valueClicked) => {
      const range = quillRef.current?.getSelection(true);

      const index = range?.index ?? 0;

      quillRef.current?.insertEmbed(
        index,
        'customVariable',
        valueClicked,
        Quill.sources.USER,
      );

      setTimeout(() => quillRef.current?.setSelection(index + 1, 0), 0);
    },
    [quillRef],
  );

  const mappedItems = useMemo(
    () =>
      Object.values<{ variable: string }>(variables).map(({ variable }) => ({
        label: variable,
        onClick: () => handleClickValue(variable),
      })),
    [handleClickValue, variables],
  );

  return (
    <Dropdown items={mappedItems} position="right">
      <ToolbarItem
        onMouseDown={() => setForceEditorFocus?.(true)}
        onClick={() => true}
        icon={<FontAwesomeIcon iconName="percent" height="16px" />}
        dataTestId="custom-variables-action"
        ariaLabel={s__('QuillEditorAccessibility|Add a custom variable')}
        tooltip={s__('QuillEditorAccessibility|Add a custom variable')}
        enableFontAwesomeIcon
      />
    </Dropdown>
  );
};

export default CustomVariables;
